import React, { useState } from "react";
import Input from "../../components/common/input";

const HelpStandardFunctions = () => {
  return (
    <div className="container-fluid">
      <h1 className="display-2">Standard Functions</h1>
      <p className="lead">Under Construction...</p>
      <AddSub />
    </div>
  );
};

const AddSub = () => {
  const [result, setResult] = useState(70);
  const [inputs, setInputs] = useState([
    { id: 1, sequence: -1, value: 10 },
    { id: 2, sequence: 2, value: 10 },
    { id: 3, sequence: 3, value: 50 },
  ]);

  const handleChangeValue = ({ currentTarget: input }) => {
    const newInputs = [...inputs];
    newInputs[input.name].value = input.value;
    setInputs(newInputs);
    calculateResult();
  };
  const handleChangeSeq = ({ currentTarget: input }) => {
    const newInputs = [...inputs];
    newInputs[input.name].sequence = input.value;
    setInputs(newInputs);
    calculateResult();
  };

  const calculateResult = () => {
    const add = inputs
      .filter((i) => parseInt(i.sequence) > 0)
      .map((i) => parseFloat(i.value))
      .reduce((p, acc) => (acc += p), 0);
    const sub = inputs
      .filter((i) => parseInt(i.sequence) < 0)
      .map((i) => parseFloat(i.value))
      .reduce((p, acc) => (acc += p), 0);
    setResult(add - sub);
  };

  return (
    <FunctionTemplate
      title="Add Sub"
      subtitle="Addition and Subtraction"
      result={result}
      inputs={inputs}
      handleChangeSeq={handleChangeSeq}
      handleChangeValue={handleChangeValue}
    />
  );
};

const FunctionTemplate = ({
  title,
  subtitle,
  description = "",
  result,
  inputs,
  handleChangeSeq,
  handleChangeValue,
}) => {
  return (
    <div className="row">
      <div className="container">
        <h4 class="card-title">{title}</h4>
        <h5 class="card-title">{subtitle}</h5>
        <div
          className="row"
          style={{
            backgroundColor: "#ECECEC",
            padding: "10px",
            borderLeft: "6px solid dodgerblue",
          }}
        >
          <div className="col-4">
            <h5 className="text-muted">Result</h5>
            <p className="display-4">{result}</p>
          </div>
          <div className="col-8">
            {inputs.map((input, index) => (
              <div className="row" key={index}>
                <div className="col-2 mr-0 pr-0">
                  <Input
                    name={index}
                    placeholder="Seq"
                    value={input.sequence}
                    onChange={handleChangeSeq}
                  />
                </div>
                <div className="col-10 ml-0 pl-0">
                  <Input
                    key={index}
                    name={index}
                    placeholder="Value"
                    value={input.value}
                    onChange={handleChangeValue}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpStandardFunctions;
